import { Image } from 'antd-mobile';
import './index.less'
import { isMobile } from '@/utils/common'
// 图片
import phoneAddressPng from '@/image/ContactUs/phone_address.jpg'
import addressPng from '@/image/ContactUs/address.jpg'
// 组件
import WebInfo from '@/component/WebInfo/index'

const infoBox = <div className='info-box'>
  <h1>安徽省悠悦软件科技有限公司</h1>
  <p>地址：深圳市宝安区航城街道泰华梧桐岛</p>
  <p>联系方式：05628292966</p>
  <p>客服邮箱：kefu@love-uu.com</p>
</div>

const ContactUs = () => {
  return (
    <div className='contact-us-page'>
      <div className='map'>
        <Image src={isMobile() ? phoneAddressPng : addressPng} className='map' fit='contain' />

        { isMobile() ? '' : infoBox }
      </div>

      { isMobile() ? infoBox : '' }

      <WebInfo />
    </div>
  )
}

export default ContactUs